import React, { useState } from "react";
import { Col, Typography, Button, Select } from "antd";
import { EditOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import styles from "../CardDetails/CardDetailsTabs/DetailsTab/DetailsTabStyle.module.scss"
import { useSelector } from "react-redux";
import { CUSTOMER, SHORT_VIDEO_FORM, LONG_VIDEO_FORM } from "../../api/Constants";
import { errorToast, getIconComponent, successToast } from "../../api/Util";
import { getVideoTagType } from "../../helpers/commonHelper";
import { getCardDetail, updateVideoTagType } from "../../services/cardsService";

const VideoTagTypeSection = ({ card, setCardDetail }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [videoTagTypeValue, setVideoTagTypeValue] = useState(card?.video_tag_type);
  const [showVideoListTagCount, setShowVideoListTagCount] = useState(false);
  const [videoListTagTypeCount, setVideoListTagTypeCount] = useState(card?.video_list_tag_type_count);

  const props = useSelector((state) => state);
  const loggedInUser = props.auth?.loggedInUser;
  const isMobile = window.innerWidth <= 768;

  const handleVideoTagTypeChange = (value) => {
    if (value === SHORT_VIDEO_FORM && card?.video_tag_type !== SHORT_VIDEO_FORM) {
      setShowVideoListTagCount(true);
    } else {
      setShowVideoListTagCount(false);
    }
    setVideoTagTypeValue(value);
  };

  const handleUpdate = async () => {
    const payload = {
      card_id: card.card_id,
      video_tag_type: videoTagTypeValue,
      ...(videoListTagTypeCount && { video_list_tag_type_count: videoListTagTypeCount })
    };
    const data = await updateVideoTagType(payload);
    if (data?.status) {
      successToast("Video Tag Type updated!");
      setIsEditing(false);
      // Refresh card details in parent
      if (setCardDetail) {
        const detail = await getCardDetail(card.card_id);
        if (detail.status) setCardDetail(detail.data);
      }
    } else {
      errorToast(data?.error);
    }
  };

  if (!card?.video_tag_type) return null;

  return (
    <div className="video-tag-type-section">
      <Col span={isMobile ? 16 : 8} className={styles.iconsAndText}>
        {getIconComponent("aspect-ratio")}
        <Typography.Text className={styles.headingFontStyle}>
          Video Tag Type :
        </Typography.Text>
      </Col>
      <Col
        span={isMobile ? 8 : 16}
        style={{
          display: "flex",
          justifyContent: isMobile ? "flex-end" : "flex-start",
          alignItems: "center",
        }}
      >
        {!isEditing ? (
          <>
            <Typography.Text
              className={`${styles.greyFontColor} ${styles.fontTwelve} ${styles.videoTagTypeContent}`}
            >
              {getVideoTagType(card?.video_tag_type)}
            </Typography.Text>
            {loggedInUser.client_type !== CUSTOMER && (
              <Button
                type="primary"
                icon={<EditOutlined />}
                className={`${styles.editOutlinedBtn} ${styles.editTagBtn}}`}
                size={"large"}
                tooltip="Edit content"
                onClick={() => {
                  setIsEditing(true);
                  setVideoTagTypeValue(card?.video_tag_type);
                }}
              />
            )}
          </>
        ) : (
          <>
            <Select
              id="select-video_purpose"
              name="video_tag_type"
              onChange={handleVideoTagTypeChange}
              value={videoTagTypeValue}
              className={styles.videoListDropdown}
            >
              <option value={""}>Select Video Type</option>
              <option value={SHORT_VIDEO_FORM}>
                Short Video Form(SF = 0.25 credits)
              </option>
              <option value={LONG_VIDEO_FORM}>
                Long Video Form(LF = 1 credit)
              </option>
            </Select>
            {showVideoListTagCount && (
              <Select
                id="video-list-tag-type"
                name="video_list_tag_type_count"
                onChange={(value) => setVideoListTagTypeCount(value)}
                value={videoListTagTypeCount}
                className={styles.videoListDropdown}
              >
                <option value="">Select Video Count</option>
                <option value="video_1">Video 1</option>
                <option value="video_2">Video 2</option>
                <option value="video_3">Video 3</option>
                <option value="video_4">Video 4</option>
              </Select>
            )}
            <Button
              icon={<SaveOutlined />}
              className={`${styles.updateTagBtn} standard-btn`}
              size={"large"}
              tooltip="Update"
              onClick={handleUpdate}
            >
              Update
            </Button>
            <Button
              icon={<CloseOutlined />}
              className={`${styles.updateTagBtn}`}
              size={"large"}
              tooltip="Cancel"
              onClick={() => setIsEditing(false)}
              style={{ marginLeft: 8 }}
            />
          </>
        )}
      </Col>
    </div>
  );
};

export default VideoTagTypeSection;
